/* assets/story-coverflow.js */
(function () {
  function init(root) {
    if (root.__scReady) return;
    root.__scReady = true;

    var track = root.querySelector('[data-sc-track]');
    var thumb = root.querySelector('[data-sc-thumb]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sc-card]'));
    if (!track || !cards.length) return;
    var bar = thumb ? thumb.parentElement : null;

    function update() {
      var tr = track.getBoundingClientRect();
      var center = tr.left + tr.width / 2;
      var closest = 0, best = Infinity;

      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        var d = (r.left + r.width / 2 - center) / r.width;   // 0 = centered, ±1 = neighbour
        var a = Math.min(Math.abs(d), 1.5);
        var scale = 1 - Math.min(a, 1) * 0.16;
        var bright = 1 - Math.min(a, 1) * 0.3;
        card.style.transform = 'scale(' + scale.toFixed(3) + ')';
        card.style.filter = a < 0.05 ? 'none' : 'brightness(' + bright.toFixed(2) + ')';
        card.style.zIndex = String(100 - Math.round(a * 10));
        if (a < best) { best = a; closest = i; }
      });

      cards.forEach(function (c, i) { c.classList.toggle('is-active', i === closest); });

      if (thumb && bar) {
        var w = bar.clientWidth / cards.length;
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 0;
        thumb.style.width = w + 'px';
        thumb.style.transform = 'translateX(' + p * (bar.clientWidth - w) + 'px)';
      }
    }

    function goTo(i) {
      var c = cards[Math.max(0, Math.min(cards.length - 1, i))];
      track.scrollTo({
        left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }

    function activeIndex() {
      return Math.max(0, cards.findIndex(function (c) { return c.classList.contains('is-active'); }));
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function (e) {
        if (!card.classList.contains('is-active')) { e.preventDefault(); goTo(i); }
      });
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(activeIndex() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(activeIndex() - 1); }
    });

    // mouse drag on desktop
    var down = false, sx = 0, sl = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; sx = e.clientX; sl = track.scrollLeft;
      track.style.scrollSnapType = 'none';
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      if (Math.abs(e.clientX - sx) > 4) moved = true;
      track.scrollLeft = sl - (e.clientX - sx);
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      track.style.scrollSnapType = '';
      if (moved) goTo(activeIndex());
    });

    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);

    // start on the first card, then paint
    track.scrollLeft = 0;
    update();
    setTimeout(update, 250);
    window.addEventListener('load', update);
  }

  function initAll() { document.querySelectorAll('[data-sc]').forEach(init); }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  initAll();
})();